module.exports = __webpack_public_path__ + "static/media/agileIcon.0ee160e1.png";